import { AdResAdPage } from './AdResAdPage';

export const adResAdRouter = {
  '/@/advance_reservation_ad': AdResAdPage,
};
